import { render, staticRenderFns } from "./assignmentPanel.vue?vue&type=template&id=c80163c0&scoped=true&"
import script from "./assignmentPanel.vue?vue&type=script&lang=js&"
export * from "./assignmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./assignmentPanel.vue?vue&type=style&index=0&id=c80163c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80163c0",
  null
  
)

export default component.exports